<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

        <div class="flex flex-wrap flex-col sm:flex-row gap-2">
              <!-- search -->
            <div class="min-w-48 relative">
                <input [(ngModel)]="search" class="pl-8" (input)="onSearchInput()" type="text" placeholder="Search.."
                 />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>

            <!-- Date picker -->

                <div class="min-w-48">
                    <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                        (ngModelChange)="onDateChange($event)" [owlDateTimeTrigger]="date" [selectMode]="'range'" [readOnly]="true" />
                    <owl-date-time [pickerType]="'calendar'" #date></owl-date-time>
                </div>

            <!-- company Selector -->
            <div *ngIf="selectedStatus !== 'scheduled' " class="min-w-48">
                <ng-select id="" [(ngModel)]="selectedCompany" (change)="onCompanyChange()" [clearable]="false">
                    <ng-option value="">Select Company</ng-option>
                    <ng-option *ngFor="let company of companies" value="{{company.id}}">{{ company.name | titlecase }}
                    </ng-option>
                </ng-select>
            </div>

            <!-- service areas selector -->
            <div class="min-w-48">
                <ng-select  [(ngModel)]="selectedServiceArea" (change)="onServiceAreaChange()" [clearable]="false">
                    <ng-option value="">Select Service Area</ng-option>
                    <ng-option *ngFor="let serviceArea of serviceAreas" value="{{serviceArea.id}}">{{ serviceArea.title | titlecase }}</ng-option>
                </ng-select>
            </div>
            <div class="min-w-48 max-w-48">
                <ng-select id="member" [notFoundText]="'No record found'" placeholder="Select Member" [clearable]="true"
                    [(ngModel)]="selectedMembers" (scrollToEnd)="onScroll()" [searchable]="true"
                    (search)="onSearch($event)" [searchable]="true" (clear)="onClear()" (close)="onClose()"
                    (change)="onMembersChange($event)" >
                   
                    <ng-option *ngFor="let member of members" value="{{ member.id }}">
                        {{(member.displayName | titlecase ) + (member.contactNumber ? " - " + member.contactNumber : "")}}
                    </ng-option>
                </ng-select>

            </div>

            <!-- payment status selector -->
            <div class="min-w-48">
                <ng-select [(ngModel)]="selectedPaymentStatus" (change)="onPaymentStatusChange()" [clearable]="false">
                    <ng-option value="">All Payments</ng-option>
                    <ng-option value="unpaid">Unpaid</ng-option>
                    <ng-option value="paid">Paid</ng-option>
                </ng-select>
            </div>

            <!-- payment type selector -->
            <div class="min-w-48">
                <ng-select [(ngModel)]="selectedPaymentType" (change)="onPaymentTypeChange()" [clearable]="false">
                    <ng-option value="">All Payment Types</ng-option>
                    <ng-option value="none">None</ng-option>
                    <ng-option value="manual">Manual</ng-option>
                    <ng-option value="square">Square</ng-option>
                    <ng-option value="quickbook">Quickbook</ng-option>
                </ng-select>
            </div>
            <div></div>
            <div></div>

            <div *ngIf="filterdataList && filterdataList.length" class="flex items-center">
            <h1 class=" text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filterdataList != 50? (50
                -filterdataList.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        </div>
    <div class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
        <div>
            <button [appToolTip]="'Filter'" type="button" (click)="toggleDropdown($event)" class="btn btn-secondary" id="menu-button"
                aria-expanded="true" aria-haspopup="true">
    
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                </svg>
                  <span 
             *ngIf="( selectedCorporateUser &&  selectedCorporateUser.length > 0)"
              class="flex absolute h-3 w-3 -top-1 -right-1">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
              <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>
            </button>
        </div>
        <div *ngIf="isDropdownOpen"
            class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
            role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="p-3 grid grid-cols-2 gap-2" role="none">
                <!-- <hr  class="sm:col-span-2 dark:border-white/10"> -->
                <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1" id="menu-item-1">
                    <div class="p-1 grid grid-cols-1 gap-1">
                <ng-select id="select-corporate" class="mt-1" [(ngModel)]="selectedCorporateUser" (change)="onFundingSourceChange()"
                    [clearable]="false" [searchable]="true">
                    <ng-option value="">-- Select Funding Source --</ng-option>
                    <ng-option *ngFor="let user of fundingSources" [value]="user.id">
                        {{ user.title | titlecase}}
                    </ng-option>
                </ng-select>
                        <button type="button" class="btn btn-primary text-xs"
                            (click)="downloadRawReport()">
                            Raw Report
                        </button>

                        <button *ngIf="selectedTrips && selectedTrips.length" type="button" class="btn btn-primary text-xs"
                            (click)="openParamountModal()">
                            Trip Report
                        </button>

                        <button *ngIf="permissionService.hasPermission([userPermission.MANAGE_BILLINGS]) && hasUnpaidSelectedTrips()" type="button"
                            class="btn btn-primary text-xs" [disabled]="isGeneratingInvoice" (click)="generateInvoice()">
                            Generate Invoice
                        </button>

                        <button *ngIf="selectedTrips && selectedTrips.length && selectedCorporateUser" type="button"
                            class="btn btn-primary text-xs" (click)="downloadModivcareReport()">
                         <div *ngIf="reportLoader.isLoading" class="">
                               <svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                style="margin: auto; display: block; shape-rendering: auto;" class="h-6" viewBox="0 0 100 100"
                                preserveAspectRatio="xMidYMid">
                                <path fill="none" stroke="#fff" stroke-width="8" stroke-dasharray="42.76482137044271 42.76482137044271"
                                    d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                                    stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px">
                                    <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1"
                                        values="0;256.58892822265625"></animate>
                                </path>
                            </svg>
                         </div>
                            Modivcare Report
                        </button>

                        <button *ngIf="selectedCorporateUser && selectedMembers" type="button" class="btn btn-primary text-xs"
                            (click)="openRNSModal()">
                            RNS Invoice
                        </button>

                        <button *ngIf="selectedTrips && selectedTrips.length && selectedCorporateUser" type="button" class="btn btn-primary text-xs"
                            (click)="downloadForm837()">
                            Form 837
                        </button>

                    </div>
                </div>
    
            </div>
        </div>
    </div>
    </div>

    <div *ngIf="selectedTrips && selectedTrips.length " class="w-36 rounded-xl bg-gray-200 dark:bg-zinc-950 px-2 py-2">
        <dl class="flex items-center">
            <dt class="grid place-content-center flex-shrink-0 rounded-lg bg-main-base">
                <svg class="h-8 w-8 text-main-primary" fill="currentColor" viewBox="0 0 24 24" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
                        <g fill="currentColor" fill-rule="nonzero">
                            <path
                                d="M20.4961766,5.62668182 C21.3720675,5.93447702 22,6.76890777 22,7.75 L22,17.75 C22,20.0972102 20.0972102,22 17.75,22 L7.75,22 C6.76890777,22 5.93447702,21.3720675 5.62668182,20.4961766 L7.72396188,20.4995565 L17.75,20.5 C19.2687831,20.5 20.5,19.2687831 20.5,17.75 L20.5,7.75 L20.4960194,7.69901943 L20.4961766,5.62668182 Z M17.246813,2 C18.4894537,2 19.496813,3.00735931 19.496813,4.25 L19.496813,17.246813 C19.496813,18.4894537 18.4894537,19.496813 17.246813,19.496813 L4.25,19.496813 C3.00735931,19.496813 2,18.4894537 2,17.246813 L2,4.25 C2,3.00735931 3.00735931,2 4.25,2 L17.246813,2 Z M13.4696699,7.46966991 L9.58114564,11.3581942 L8.6,10.05 C8.35147186,9.71862915 7.88137085,9.65147186 7.55,9.9 C7.21862915,10.1485281 7.15147186,10.6186292 7.4,10.95 L8.9,12.95 C9.17384721,13.3151296 9.70759806,13.3530621 10.0303301,13.0303301 L14.5303301,8.53033009 C14.8232233,8.23743687 14.8232233,7.76256313 14.5303301,7.46966991 C14.2374369,7.1767767 13.7625631,7.1767767 13.4696699,7.46966991 Z">
                            </path>
                        </g>
                    </g>
                </svg>
            </dt>
            <dd class="w-full ml-4 truncate text-right">
                <div class="text-xs text-main-light flex-1 "> Selected Trips </div>
                <div class="text-sm font-bold text-main-secondary flex-1 truncate">{{selectedTrips.length}}</div>
            </dd>
        </dl>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full table-auto border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #</th>

                                    <th *ngIf="filterdataList.length && permissionService.hasPermission([userPermission.MANAGE_BILLINGS])"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <input type="checkbox"
                                            [checked]="selectedTrips.length && selectedTrips.length === filterdataList.length"
                                            (change)="onSelectAllTrips($event)" />
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action</th>
                                    <!-- <th
                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                    Status</th> -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Service Area</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Reference ID
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Association
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Funding Source
                                    </th>
                                    <th *ngIf="selectedStatus !== 'scheduled' "
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Company</th>
                                    <th *ngIf="selectedStatus !== 'scheduled' "
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Driver</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Member</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Contact No.</th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pickup Time
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Dropoff Time
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pickup Address</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Dropoff Address</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Miles</th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Space Type</th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        LOS</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Appointment Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Onway</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Arrived</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Inprogress</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Completed</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Fare</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Pre Special Fare</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Special Fare</th>
                                         <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Offered Fare</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Addon Fare</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Created At </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Batch </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Status</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Type</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        General Notes</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Billing Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let trip of filterdataList  | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i = index ; "
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10" [ngClass]="{'bg-gray-950/5 dark:bg-white/10': trip.isSelected}">

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td  *ngIf="permissionService.hasPermission([userPermission.MANAGE_BILLINGS]) && trips.length "
                                        class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <!-- Selected row marker, only show when row is selected. -->
                                        <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary"
                                            [ngClass]="{'hidden': !trip.isSelected}">
                                        </div>
                                        <input (click)="onSelectTrip(trip)" type="checkbox"
                                            [(ngModel)]="trip.isSelected"
                                            
                                            type="checkbox" />
                                    </td>
                                    <!-- actions -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex">
                                            <button [appToolTip]="'Detail'" (click)="opendetailModal(trip)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                            </button>

                                            <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <button [appToolTip]="'Notes'" (click)="openNotesModal(trip)"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                                    viewBox="0 0 24 24" class="h-5 w-5">
                                                    <path fill="currentColor"
                                                        d="M7.154 13.539q.31 0 .54-.23q.229-.23.229-.54t-.23-.54t-.54-.229t-.538.23t-.23.54q0 .309.23.539t.539.23m0-2.77q.31 0 .54-.23q.229-.23.229-.539t-.23-.54t-.54-.23t-.538.23t-.23.54t.23.54t.539.23m0-2.77q.31 0 .54-.23t.229-.54t-.23-.539t-.54-.23t-.538.23t-.23.54t.23.54t.539.229m3.077 5.27H14.5v-1h-4.27zm0-2.77H17.5v-1h-7.27zm0-2.77H17.5v-1h-7.27zM3 20.078V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z" />
                                                </svg>
                                            </button>

                                            <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <div class="inline-flex relative"
                                                >
                                                <!-- *ngIf="!assign.isJClone" -->
                                                <a *ngIf="!trip.isSelected" href="javascript:void(0)"
                                                     [appToolTip]="'More Actions'" (click)="showActionButtons(i)"
                                                    class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                        class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                    </svg>
                                                </a>
                                                <div (outsideClick)="closeActionMenu($event)" outside-click
                                                    *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                                    class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                                    role="menu" aria-orientation="vertical"
                                                    aria-labelledby="menu-button" tabindex="-1">
                                                    <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                                                    <app-trip-action-dropdown
                                                        class="divide-y divide-zinc-950/10 dark:divide-white/10"
                                                        [trip]="trip" [source]="'fsbilling'"
                                                        (detail)="opendetailModal($event)"
                                                        (adjustFundingSourceTrip)="openAdjustTrip($event)"
                                                        (signature)="openSignatureModal($event)"
                                                        (logs)="openLogModal(trip)"
                                                        (invoiceModal)="openRNSModal(trip)"
                                                        (form837)="downloadForm837(trip)"
                                                        [canPay]="trip.payment?.status !== 'paid'"
                                                        (pay)="openPayModal($event)"
                                                    >
                                                    </app-trip-action-dropdown>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <!-- status -->
                                    <!-- <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap"><span
                    class="my-1 badge-success"> {{trip.status | titlecase}} </span></td> -->
                                    <!-- Service Areas -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                                            {{preServiceAreas[trip.serviceArea].title ?
                                            (preServiceAreas[trip.serviceArea].title | titlecase)
                                            :
                                            'N/A'}}
                                        </span>
                                    </td>
                                    <!-- Reference -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>
                                            {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                                        </span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>
                                            {{trip.association || 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- --Funding Source-- -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preFundingSource && trip.fundingsource">
                                            {{preFundingSource[trip.fundingsource]?.title | titlecase}}
                                        </span>
                                    </td>
                                    <!-- company -->
                                    <td *ngIf="selectedStatus !== 'scheduled'"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span *ngIf="preCompanies && preCompanies[trip.company]; else elseBlock">
                                                {{ (preCompanies[trip.company].name | titlecase) || 'N/A' }}
                                            </span>
                                            <span class="text-[12px]"
                                                *ngIf="trip.company && preCompanies[trip.company] && preCompanies[trip.company].timeZone">
                                                ({{ ((preCompanies[trip.company].timeZone | titlecase)) }})
                                            </span>
                                        </div>
                                    </td>

                                    <!-- company -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="trip.driver;else elseBlock">
                                            {{(trip.driver?.displayName | titlecase)|| 'N/A'}}
                                        </span>
                                    </td>
                                    <!-- member -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span>
                                            {{trip?.member?.displayName | titlecase}}
                                        </span>
                                    </td>
                                    <!-- phoneNumber -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap"
                                        phoneNumberFormat [phoneNumber]="trip?.member?.contactNumber">
                                        {{ trip?.member?.contactNumber || 'N/A'}}
                                    </td>
                                    <!-- pickuptime -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{trip?.pickup.time | date: 'MM/DD/YYYY HHmm'}}</span>
                                            <span class="text-primary"
                                                *ngIf="trip.company && preCompanies[trip.company] && preCompanies[trip.company].timeZone">
                                                (CT: {{ trip?.pickup.time | date:'MM/DD/YYYY HHmm' :
                                                ((preCompanies[trip.company].timeZone) | titlecase) }})
                                            </span>
                                        </div>
                                    </td>
                                    <!-- DO time -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{trip?.destination.time | date: 'MM/DD/YYYY HHmm'}}</span>
                                            <span class="text-primary"
                                                *ngIf="trip.company && preCompanies[trip.company] && preCompanies[trip.company].timeZone">
                                                (CT: {{ trip?.destination.time | date:'MM/DD/YYYY HHmm' :
                                                preCompanies[trip.company].timeZone }})
                                            </span>
                                        </div>
                                    </td>
                                    <!-- pickup address -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip?.pickup?.address?.name}}</td>
                                    <!-- destination address -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip?.destination?.address?.name}}</td>
                                    <!-- miles -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                         {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : '' }}</td>
                                    <!-- spaceType -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType];else elseBlock">
                                            {{preSpacetypes[trip.spaceType].title | uppercase}}
                                        </span>
                                    </td>
                                    <!-- LOS -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span
                                            *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService];else elseBlock">
                                            {{preLevelOfService[trip.levelOfService].title | uppercase}}
                                        </span>
                                    </td>
                                    <!-- appointmentType -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]; else elseBlock">
                                            {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                                        </span>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{ (trip.onway?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                            <span class="text-primary"
                                                >
                                                <span *ngIf="trip.onway?.latitude && trip.onway?.longitude">({{trip.onway?.latitude + ',' + trip.onway?.longitude}})</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{ (trip.arrived?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                            <span class="text-primary">
                                                <span *ngIf="trip.arrived?.latitude && trip.arrived?.longitude">({{trip.arrived?.latitude + ',' +  trip.arrived?.longitude}})</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{ (trip.inProgress?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                            <span class="text-primary">
                                                <span *ngIf="trip.inProgress?.latitude && trip.inProgress?.longitude">({{trip.inProgress?.latitude + ',' + trip.inProgress?.longitude}})</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div class="flex flex-col gap-0 leading-tight">
                                            <span>{{ (trip.completed?.time | date: 'MM/DD/YYYY HHmm') || '—' }}</span>
                                            <span class="text-primary">
                                                <span *ngIf="trip.completed?.latitude && trip.completed?.longitude">({{trip.completed?.latitude + ',' + trip.completed?.longitude}})</span>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="trip.status === 'cancelled'">
                                            $ {{
                                            (trip?.flags?.isNoShow && trip?.fare?.cancelBreakdown?.noShowCharges)
                                            ? trip?.fare?.cancelBreakdown?.noShowCharges
                                            : trip?.fare?.cancelBreakdown?.cancelCharges || 0
                                            }}
                                        </span>
                                        <span *ngIf="trip.status === 'completed'">
                                           $ {{trip?.fare?.breakdown?.total ? trip?.fare?.breakdown?.total : 0}}
                                        </span>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                                        <span>
                                            ${{ trip.preSpecialRate || 0}}
                                        </span>
                                    </td>
                                       <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span >
                            ${{ trip.specialRate || 0}}
                        </span>
                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="trip.offeredFare && trip.offeredFare.breakdown">${{trip.offeredFare.breakdown.total}}</span>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <span *ngIf="trip.fare && trip.fare.breakdown && trip.fare.breakdown.addonFareFixed else elseBlock">${{trip.fare.breakdown.addonFareFixed}}</span>
                                    </td>                                          
                                    <!-- createdAt -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip.createdAt | date: 'MM/DD/YYYY HHmm'}}</td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{trip.billingBatch || 'N/A'}}</td>
                                    <td
                                        class=" px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div [ngClass]="trip.status === 'cancelled' ? 'badge-danger' : 'badge-success'">
                                            {{trip.status | titlecase }}
                                        </div>
                                    </td>
                                    <!-- payment status -->
                                    <td
                                        class=" px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        <div
                                            [ngClass]="{'badge-success': trip.payment?.status === 'paid', 'badge-primary': trip.payment?.status === 'unpaid'}">
                                            {{ (trip.payment?.status | titlecase) || 'N/A' }}
                                        </div>
                                    </td>
                                    <!-- payment type -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap whitespace-nowrap">
                                        {{ (trip.payment?.relationType !== 'none' && (trip.payment?.relationType | titlecase)) || 'N/A' }}
                                        <div *ngIf="trip.payment?.reference" class="text-xs">{{ trip.payment.reference }}</div>
                                    </td>
                                    <!-- generalNotes -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                                        <div class="w-72 line-clamp-2">
                                            {{ trip.generalNotes || 'N/A'}}
                                        </div>
                                    </td>
                                    <!-- billing notes -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                                        <div class="w-72 line-clamp-2">
                                            {{trip.billingNotes || 'N/A'}}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <ng-template #elseBlock>N/A</ng-template>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>

    </div>


</section>


<app-trip-detail-modal *ngIf="tripId" [source]="'fundingsourceBilling'" [tripId]="tripId" (closeModal)="tripId = null"></app-trip-detail-modal>
<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj" [source]="'fundingsourceBilling'" (closeModal)="memberNotesObj = null"></app-notes-modal>
<app-report-configuration-modal *ngIf="(paramountLoader.isModal || rideNSafe.isModal) && ((selectedTrips && selectedTrips.length) || (rnsSingleTrip && rnsSingleTrip.length))" [source]="'fundingsourceBilling'" [reportSource]="reportSource"
    [selectedTrips]="rnsSingleTrip && rnsSingleTrip.length ? rnsSingleTrip : selectedTrips" [user]="user" [selectedCorporate]="selectedCorporateObj"
    [preLevelOfService]="preLevelOfService"
    (onCloseModal)="paramountLoader.isModal = false; rideNSafe.isModal = false; rnsSingleTrip = null" [todayDate]="todayDate">
</app-report-configuration-modal>
<app-trip-signature-modal *ngIf="signatureModalObj" [trip]="signatureModalObj" [source]="'fundingsourceBilling'" (closeModal)="onCloseSignatureModal($event)"></app-trip-signature-modal>
<app-trip-logs-modal *ngIf="logObj" [source]="'fundingsourceBilling'" [tripId]="logObj" (closeModal)="logObj = null"></app-trip-logs-modal>

<app-manual-payment-modal *ngIf="payModalObj" [trip]="payModalObj" [relation]="payRelation"
    (closeModal)="onClosePayModal($event)"></app-manual-payment-modal>
